export function trimNumericInput(input: string): string {
  return input ? input.replace(/,/g, '').replace(/%/g, '').trim() : null;
}
